module.exports = __webpack_public_path__ + "img/box-03.00adb2e5.svg";